import { render, staticRenderFns } from "./RunSpeedChart.vue?vue&type=template&id=25023f3e&"
import script from "./RunSpeedChart.vue?vue&type=script&lang=js&"
export * from "./RunSpeedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports